// Effective-status resolution shared by every Homeschool component that
// displays or reasons about a mastery claim. A parent override (Phase 6)
// never mutates the server-computed `status` field - it lives in a
// separate `parentOverride` sub-document (see
// db_backend/models/SkillMastery.js) - so any UI that reads `.status`
// directly will silently ignore an override the parent already set. Mirror
// of db_backend/services/masteryService.js's `effectiveStatus`.

export type MasteryStatus = 'not-attempted' | 'emerging' | 'developing' | 'secure';

export interface ParentOverride {
  status: MasteryStatus;
  setBy?: string;
  setAt?: string;
  note?: string;
}

export interface MasteryLike {
  status?: string;
  parentOverride?: ParentOverride | null;
}

export function effectiveStatus(mastery?: MasteryLike | null): MasteryStatus {
  return (mastery?.parentOverride?.status || mastery?.status || 'not-attempted') as MasteryStatus;
}
